import React from 'react';
import Form from './Form';
import MapComponent from './Mapcomponent';

const Contact = () => {
  return (
    <div>
       <section className="contact-section">
      <div className="quick-contact">
        <h3>Quick Contact</h3>
        <p>If you have any questions, simply use the following contact details.</p>
        <p><strong>Address:</strong> Vill. Theepuri, Shamshabad Road, Fatehabad (Agra)</p>
        <p><strong>Email:</strong> sr6018@gmail.com.com</p>
        <p><strong>Phone:</strong> +91 8909861356</p>
        <MapComponent/>
      </div>
      <div className="get-in-touch">
        <h3>Get In Touch</h3>
        <form>
          <div className="form-group">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email Id" />
          </div>
          <input type="text" placeholder="Phone" />
          <textarea placeholder="Your Message..."></textarea>
          <button type="submit">Submit</button>
        </form>
      </div>
    </section>
    </div>
  );
};

export default Contact;
